const BASE_PATH = '';

/**
 * ###################################
 * @description moashelf path
 * ###################################
 */
export enum MOASHELF_PATH {
  // root path
  // landing path
  LANDING_PATH = '/ms/',
  // begin path
  BEGIN_PATH = '/ms/begin',
  // shelf path
  SHELF_PATH = '/ms/shelf',
  SHELF_KEY_PATH = '/ms/shelf/:shelfKey',
  // subscription path
  SUBSCRIPTION_PATH = '/ms/subscription',
  // article path
  ARTICLE_PATH = '/ms/article',
  ARTICLE_KEY_PATH = '/ms/article/:articleKey',
  // note path
  NOTE_PATH = '/ms/note',
  // provider path
  PROVIDER_PATH = '/ms/provider',
  PROVIDER_KEY_PATH = '/ms/provider/:providerKey',
}
